import { render, staticRenderFns } from "./CatalogoServicios.vue?vue&type=template&id=c2c357a8&"
import script from "./CatalogoServicios.vue?vue&type=script&lang=js&"
export * from "./CatalogoServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports